const padNumber = (num: number): string => num.toString().padStart(2, '0');
export const getDateString = (date: Date): string =>
  `${date.getFullYear()}-${padNumber(date.getMonth() + 1)}-${padNumber(date.getDate())}T00:00:00`;
